import React from "react";
import { Card, CardContainer } from "../../../../components/Card";
import { BarChart, LineChart, PieChart } from "../../../../components/Charts";

const AppPrograms = ({ data }) => {
    return (
        <>
            <CardContainer>
                <div
                    style={{
                        display: "flex",
                        width: "40%",
                        justifyContent: "space-between",
                    }}
                >
                    <PieChart
                        data={data?.map((i) => ({
                            ...i,
                            payout_pending:
                                (i.total_applicants ?? 0) -
                                (i.payout_completed ?? 0),
                        }))}
                        series={[
                            {
                                key: "payout_completed",
                                name: "Payout Completed",
                            },
                            {
                                key: "payout_pending",
                                name: "Payout Pending",
                            },
                        ]}
                        title="Overall Progress"
                    />
                </div>

                <BarChart
                    data={data}
                    series={[
                        {
                            name: "Amplification",
                            key: "amplification",
                        },
                        {
                            name: "User Generated Content",
                            key: "user_generated_content",
                        },
                    ]}
                    // xLabel="Week"
                    xKey="week"
                    // yLabel="Revenue"
                    title="Amplification vs User Generated Content Stats"
                />
            </CardContainer>
            <CardContainer>
                <BarChart
                    data={data}
                    series={[
                        {
                            name: "Total Applicants",
                            key: "total_applicants",
                        },
                        {
                            name: "Total Shortlisted",
                            key: "total_shortlisted",
                        },
                        {
                            name: "Total Transacted",
                            key: "total_transacted",
                        },
                    ]}
                    xLabel="Week"
                    xKey="week"
                    yLabel="Revenue"
                    title="Applicants Stats"
                />
                <div
                    style={{
                        display: "flex",
                        width: "40%",
                        justifyContent: "space-between",
                    }}
                >
                    <BarChart
                        data={data}
                        series={[
                            {
                                name: "Community Growth",
                                key: "community_growth",
                                type: "bar",
                            },
                            {
                                name: "Community Engagement",
                                key: "community_engagement",
                                type: "bar",
                            },
                        ]}
                        xKey="week"
                        yOverlap={[
                            {
                                name: "Community Growth",
                            },
                            {
                                name: "Community Engagement",
                                opposite: true,
                            },
                        ]}
                        title="Campaign Stats"
                    />
                </div>
            </CardContainer>
            <CardContainer>
                <LineChart
                    data={data}
                    series={[
                        {
                            name: "Total Campaigns",
                            key: "total_campaigns",
                        },
                    ]}
                    xKey="week"
                    // yLabel="Seats Sold"
                    title="Campaign Week Wise"
                />
            </CardContainer>
        </>
    );
};

export default AppPrograms;
